import { TFunction } from "i18next"
import { isObject } from "lopermut"
import { ChannelEnum } from "schema"

type ConversationTitleSource = {
  campaign?: {
    name?: string | null
    channel?: keyof typeof ChannelEnum | null
  } | null
  event?: unknown
  subject?: string | null
}

export function getConversationTitle(conversation: ConversationTitleSource, t: TFunction) {
  const campaignName = conversation.campaign
    ? conversation.campaign.name || t("campaigns.untitled")
    : t("conversations.chat.noCampaign")
  const isEmailCampaign =
    conversation.campaign?.channel === ChannelEnum.Gmail ||
    conversation.campaign?.channel === ChannelEnum.Outlook
  const eventSubject = isObject(conversation.event) ? conversation.event.subject : undefined
  const subject = conversation.subject ?? eventSubject

  return isEmailCampaign && typeof subject === "string" && subject.trim()
    ? `${campaignName} - ${subject.trim()}`
    : campaignName
}
